module.exports = __webpack_public_path__ + "img/banner_mobile.3a3fa009.jpg";